import { render, staticRenderFns } from "./TOPIC.vue?vue&type=template&id=68baa757&scoped=true&"
import script from "./TOPIC.vue?vue&type=script&lang=js&"
export * from "./TOPIC.vue?vue&type=script&lang=js&"
import style0 from "./TOPIC.vue?vue&type=style&index=0&id=68baa757&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68baa757",
  null
  
)

export default component.exports